export enum ApplicationLanguage {
  ENGLISH = "en",
  SPANISH = "es",
  ITALIAN = "it",
  PORTUGUESE = "pt",
}

export enum TimeZoneLanguage {
  "Europe/London" = "en",
  "America/Mexico_City" = "es",
  "Europe/Rome" = "it",
  "America/Sao_Paulo" = "pt",
}

export enum Language {
  en = "ENGLISH",
  es = "SPANISH",
  it = "ITALIAN",
  pt = "PORTUGUESE",
}

export type langueType = "en" | "es" | "it" | "pt";
export type langueTypeTimeZone =
  | "Europe/London"
  | "America/Mexico_City"
  | "Europe/Rome"
  | "America/Sao_Paulo";
